import styled from "styled-components";
import { List, ListItem } from "@mui/material";

export const RoundPlusIcon = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #fe2f67;
  margin-right: 5px;
  margin-bottom: 8px;
  text-align: center;
  line-height: 100%;
  color: #fff;
  font-size: 1rem;
  cursor: pointer;
`;

export const RightAlignedContainer = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  width: 100%;
`;
export const SelectPopperWrapper = styled.div`
  padding: 0;
  margin: 0;
  width: 120px;
  height: 60px;
  background-color: #fff;
  border: 1px solid rgba(255, 45, 85, 0.43);
`;

export const SelectPopperList = styled.ul`
  list-style: none;
  padding-left: 5px;
  margin: 0;
  width: 100%;
  height: 100%;
  font-size: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`;

export const SelectPopperListItem = styled.li`
  padding: 0;
  margin: 0;
  width: 100%;
  height: 30px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const SelectPopperListItemText = styled.a`
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: #ff2d55;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;
